var map = {
	"./app-settings/app-settings.module.ngfactory": [
		"./src/app/app-settings/app-settings.module.ngfactory.js",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~b1c59018",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~e8031f56",
		"default~app-settings-app-settings-module-ngfactory~authentication-authentication-module-ngfactory~un~7c820dc1",
		"common",
		"app-settings-app-settings-module-ngfactory"
	],
	"./authentication/authentication.module.ngfactory": [
		"./src/app/authentication/authentication.module.ngfactory.js",
		"default~app-settings-app-settings-module-ngfactory~authentication-authentication-module-ngfactory~un~7c820dc1",
		"common",
		"authentication-authentication-module-ngfactory"
	],
	"./faculty-management/faculty-management.module.ngfactory": [
		"./src/app/faculty-management/faculty-management.module.ngfactory.js",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~b1c59018",
		"default~faculty-management-faculty-management-module-ngfactory~reporting-reporting-module-ngfactory~~84f81d37",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~e8031f56",
		"default~faculty-management-faculty-management-module-ngfactory~units-units-module-ngfactory",
		"common",
		"faculty-management-faculty-management-module-ngfactory"
	],
	"./profile/profile.module.ngfactory": [
		"./src/app/profile/profile.module.ngfactory.js",
		"common",
		"profile-profile-module-ngfactory"
	],
	"./reporting/reporting.module.ngfactory": [
		"./src/app/reporting/reporting.module.ngfactory.js",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~b1c59018",
		"default~faculty-management-faculty-management-module-ngfactory~reporting-reporting-module-ngfactory~~84f81d37",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~e8031f56",
		"common",
		"reporting-reporting-module-ngfactory"
	],
	"./search/search.module.ngfactory": [
		"./src/app/search/search.module.ngfactory.js",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~b1c59018",
		"default~faculty-management-faculty-management-module-ngfactory~reporting-reporting-module-ngfactory~~84f81d37",
		"default~search-search-module-ngfactory~units-units-module-ngfactory~user-management-user-management-~e11141e7",
		"common",
		"search-search-module-ngfactory"
	],
	"./statistics/statistics.module.ngfactory": [
		"./src/app/statistics/statistics.module.ngfactory.js",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~b1c59018",
		"common",
		"statistics-statistics-module-ngfactory"
	],
	"./units/units.module.ngfactory": [
		"./src/app/units/units.module.ngfactory.js",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~b1c59018",
		"default~faculty-management-faculty-management-module-ngfactory~reporting-reporting-module-ngfactory~~84f81d37",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~e8031f56",
		"default~search-search-module-ngfactory~units-units-module-ngfactory~user-management-user-management-~e11141e7",
		"default~app-settings-app-settings-module-ngfactory~authentication-authentication-module-ngfactory~un~7c820dc1",
		"default~faculty-management-faculty-management-module-ngfactory~units-units-module-ngfactory",
		"common",
		"units-units-module-ngfactory"
	],
	"./user-management/user-management.module.ngfactory": [
		"./src/app/user-management/user-management.module.ngfactory.js",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~b1c59018",
		"default~faculty-management-faculty-management-module-ngfactory~reporting-reporting-module-ngfactory~~84f81d37",
		"default~app-settings-app-settings-module-ngfactory~faculty-management-faculty-management-module-ngfa~e8031f56",
		"default~search-search-module-ngfactory~units-units-module-ngfactory~user-management-user-management-~e11141e7",
		"common",
		"user-management-user-management-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;